import {
    WesternIslesRecordType,
    WesternIslesRecordSubType
} from "./WesternIslesRecordTypes";

import {
    IRecordTypeFeatureInfoClick,
    RecordTypeResource,
    IRecordTypeHeading,    
    IMappingTextPack
} from "esdm-map";
import { ILayerGroup } from "esdm-map/dist/layers/groups/ILayerGroup";


let headingConfiguration = (): Array<IRecordTypeHeading> => {
    let items = new Array<IRecordTypeHeading>();

    items.push({
        recordTypeCode: WesternIslesRecordType.Monument,
        recordSubTypeCode: null,
        heading: "Monuments"
    });

    items.push({
        recordTypeCode: WesternIslesRecordType.Event,
        recordSubTypeCode: null,
        heading: "Events"
    });

    items.push({
        recordTypeCode: WesternIslesRecordType.Designation,
        recordSubTypeCode: null,
        heading: "Designations"
    });

    items.push({
        recordTypeCode: WesternIslesRecordType.Designation,
        recordSubTypeCode: WesternIslesRecordSubType.ListedBuilding,
        heading: "Listed Buildings"
    });

    items.push({
        recordTypeCode: WesternIslesRecordType.Designation,
        recordSubTypeCode: WesternIslesRecordSubType.DesignedLandscape,
        heading: "Designed Landscapes"
    });

    items.push({
        recordTypeCode: WesternIslesRecordType.Designation,
        recordSubTypeCode: WesternIslesRecordSubType.ScheduledMonument,
        heading: "Scheduled Monuments"
    });  

    items.push({
        recordTypeCode: WesternIslesRecordType.Designation,
        recordSubTypeCode: WesternIslesRecordSubType.ConservationArea,
        heading: "Conservation Areas"
    });

    items.push({
        recordTypeCode: WesternIslesRecordType.Designation, 
        recordSubTypeCode: WesternIslesRecordSubType.HistoricBattlefield,
        heading: "Historic Battlefields"
    });

    items.push({
        recordTypeCode: WesternIslesRecordType.Designation,
        recordSubTypeCode: WesternIslesRecordSubType.HistoricMarineProtectedArea,
        heading: "Historic Marine Protected Areas"
    });
    
    return items;
}

export class HbsmrRecordTypeResource extends RecordTypeResource {

    public constructor(
        private _mappingTextPack: IMappingTextPack,
    ) {
        super(headingConfiguration());
    }
    
    public groupByRecordSubTypeCode(recordTypeCode: string): boolean 
    {
        return (recordTypeCode.toLowerCase() === WesternIslesRecordType.Designation);        
    }      

    public mapToIRecordTypeInfoClick(featureProperties: any, layerGroup: ILayerGroup): IRecordTypeFeatureInfoClick 
    {
        if (layerGroup.layerSubType == WesternIslesRecordSubType.ConservationArea)
            return {
                id: featureProperties.Des_ref,
                uid: featureProperties.Des_ref,
                ref: featureProperties.Des_ref,
                name: featureProperties.Des_title,
                recordType: "desig",
                recordSubType: "Conservation Area",
                recordSubTypeCode: "COA",
                data: featureProperties,
                heading: this.getHeading(WesternIslesRecordType.Designation, WesternIslesRecordSubType.ConservationArea),
                layerGroup: layerGroup
            }
        else {
            return {
                id: featureProperties.id,
                uid: featureProperties.uid,
                ref: featureProperties.ref,
                name: featureProperties.name,
                recordType: featureProperties.rectype,
                recordSubType: featureProperties.recsubtype,
                recordSubTypeCode: featureProperties.recsubtypecode,
                data: featureProperties,
                heading: this.getHeading(featureProperties.rectype, featureProperties.recsubtypecode),
                layerGroup: layerGroup
            }
        }
    }

    public getInfoClickHtmlTemplate(recordTypeInfoClick: IRecordTypeFeatureInfoClick): string 
    {
        let html: string = "";
        let featurePropertyNameForId = "uid";
        let layerType: string = recordTypeInfoClick.layerGroup.layerType;

        if (recordTypeInfoClick.recordSubTypeCode == "COA") {
            html = `<li>
                         <span>[Des_title] ([Des_ref])</span>               
                    </li>`;
        } else {
            //add controller (or any arbitrary data) to the data object
            switch (recordTypeInfoClick.recordType.toLowerCase()) {
                case "mon":
                    recordTypeInfoClick.data.controller = "Monument";
                    break;
                case "event":
                    recordTypeInfoClick.data.controller = "Event";
                    break;
                case "desig":
                    recordTypeInfoClick.data.controller = "Designation";
                    break;
            }

            html = `
                     <li>
                        <a href="/[controller]/[${featurePropertyNameForId}]" title="${this._mappingTextPack.goToDetails}"><span><i class="far fa-info-circle" aria-hidden="true"></i></span></a>
                        &nbsp;
                        <a href="/[controller]/[${featurePropertyNameForId}]" title="${this._mappingTextPack.goToDetails}">                               
                            <span>[name]</span>               
                        </a>
                        <a class="showOnMap" title="${this._mappingTextPack.centreOnMap}" data-recordtype="${layerType}" data-id="[id]">                                                
                            <i class="far fa-map-marked-alt fa-lg" aria-hidden="true"></i>
                        </a>
                     </li>`;
        }
        return html;
    }

    
}